module.exports = __webpack_public_path__ + "aa6f5d9438b8efeadd9634bd2a80ac75.fbx";